import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import {TokenService} from './token.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private adminApiUrl = 'https://camposdeportivos.muninuevochimbote.gob.pe/api/administrador/login';
  private cashierApiUrl = 'https://camposdeportivos.muninuevochimbote.gob.pe/api/cajero/login';

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private tokenService: TokenService
  ) {}

  loginAdmin(username: string, password: string, role: string): Observable<any> {
    return this.http.post<any>(this.adminApiUrl, { username, password }).pipe(
      map((response) => {
        if (response && response.token) {
          this.tokenService.saveToken(response.token);
          this.setRoleCookie(role);
        }
        return response;
      }),
      catchError(this.handleError)
    );
  }

  loginCashier(username: string, password: string, role: string): Observable<any> {
    return this.http.post<any>(this.cashierApiUrl, { username, password }).pipe(
      map((response) => {
        if (response && response.token) {
          this.tokenService.saveToken(response.token);
          this.setRoleCookie(role);
        }
        return response;
      }),
      catchError(this.handleError)
    );
  }

  logout(): void {
    this.tokenService.removeToken();
    this.cookieService.delete('userRole');
  }

  isAdmin(): boolean {
    return this.cookieService.get('userRole') === 'Administrador';
  }

  isCajero(): boolean {
    return this.cookieService.get('userRole') === 'Cajero';
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'Ocurrió un error desconocido.';

    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error del cliente: ${error.error.message}`;
    } else {
      errorMessage = `Código del servidor: ${error.status}\nMensaje: ${error.message}`;
    }

    return throwError(() => new Error(errorMessage));
  }

  private setRoleCookie(role: string): void {
    this.cookieService.set('userRole', role, 0.125);
  }
}
